import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const get_white_list = (page, per_page, name, status) => {
  return api.post(`${ApiEndpointConstants.GETWHITELIST}`, {
    page,
    per_page,
    name,
    status,
  });
};
